import { Popover as BasePopover } from "@base-ui/react/popover";
import { useFloatingPortalContainer } from "@frontend/contexts";

import type { YearPickerPortalProps } from "./YearPicker.types";

export function YearPickerPortal({
  children,
  ...props
}: YearPickerPortalProps) {
  const container = useFloatingPortalContainer();

  return (
    <BasePopover.Portal
      data-slot="year-picker-portal"
      container={container}
      {...props}
    >
      {children}
    </BasePopover.Portal>
  );
}
